import React, { useState } from "react";
import ButtonSpinner from "../common/ButtonSpinner";
import { useTranslation } from "react-i18next";

export default function StatusModal({ open, message, success, onClose }) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  if (!open) return null;

  const handleClose = async () => {
    setLoading(true);
    await Promise.resolve(onClose());
    setLoading(false);
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0, 0, 0, 0.5)",
        backdropFilter: "blur(4px)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Inter, Segoe UI, Roboto, Arial, sans-serif",
        animation: "fadeIn 0.2s ease-out",
      }}
      onClick={handleClose}
    >
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes slideUp {
            from { 
              opacity: 0;
              transform: translateY(20px);
            }
            to { 
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
      <div
        style={{
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.15)",
          padding: "32px 24px",
          minWidth: 280,
          maxWidth: 360,
          width: "90vw",
          textAlign: "center",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          fontFamily: "inherit",
          animation: "slideUp 0.3s ease-out",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Icon */}
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            background: success
              ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
              : "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 20,
            boxShadow: success
              ? "0 8px 24px rgba(16, 185, 129, 0.25)"
              : "0 8px 24px rgba(239, 68, 68, 0.25)",
          }}
        >
          {success ? (
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path
                d="M5 13l4 4L19 7"
                stroke="#fff"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path
                d="M6 18L18 6M6 6l12 12"
                stroke="#fff"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>

        {/* Title */}
        <div
          style={{
            fontSize: 22,
            fontWeight: 700,
            color: "#1e293b",
            marginBottom: 12,
            letterSpacing: -0.3,
            fontFamily: "inherit",
          }}
        >
          {success
            ? t("StatusModal.success", "Success!")
            : t("StatusModal.error", "Error!")}
        </div>

        {/* Message */}
        <div
          style={{
            fontSize: 15,
            color: "#64748b",
            marginBottom: 24,
            wordBreak: "break-word",
            fontFamily: "inherit",
            lineHeight: 1.6,
          }}
        >
          {message}
        </div>

        {/* Button */}
        <button
          onClick={handleClose}
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "12px 40px",
            fontWeight: 600,
            fontSize: 15,
            cursor: loading ? "not-allowed" : "pointer",
            letterSpacing: 0.3,
            boxShadow: "0 4px 14px rgba(102, 126, 234, 0.3)",
            fontFamily: "inherit",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            transition: "all 0.2s ease",
            opacity: loading ? 0.7 : 1,
            minWidth: 120,
          }}
          disabled={loading}
          onMouseEnter={(e) => {
            if (!loading) e.target.style.transform = "translateY(-2px)";
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "translateY(0)";
          }}
        >
          {loading ? (
            <>
              <ButtonSpinner size={18} color="#fff" type="dots" />
              <span>{t("StatusModal.closing", "Closing...")}</span>
            </>
          ) : (
            t("StatusModal.ok", "OK")
          )}
        </button>
      </div>
    </div>
  );
}